import {WorkspacesCount} from '@shared/core';

export type MainStatistic = Omit<WorkspacesCount, 'total' | 'remote'>;

export const getPercentage = (count: number, all: number) => {
  const percentage = Number(((count * 100) / all).toFixed(0));
  return !all || !count ? 0 : percentage ? percentage : 1;
};

export const getSumStatistic = (statistic: MainStatistic) => {
  return Object.values(statistic).reduce((acc, el) => acc + el);
};

export const dataStatistic = (statistic: MainStatistic) => {
  const sum = getSumStatistic(statistic);
  return sum > 0 ? Object.values(statistic) : [100];
};
